import { Box, BoxProps, Link, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { last } from 'lodash';
import { BreadcrumbElement } from '../../interfaces/Breadcrumb/BreadcrumbElement';
import { settingsAtom } from '../../atoms/Settings';
import { useLocalizedText } from '../../hooks/useLocalizedText';

const fontSize = '14px';

const Separator = () => <Typography sx={{ fontSize }}>/</Typography>;

type GenericBreadcrumbsProps = BoxProps & {
  breadcrumbElements: BreadcrumbElement[];
};

export const GenericBreadcrumbs = ({
  breadcrumbElements,
  ...props
}: GenericBreadcrumbsProps) => {
  const t = useLocalizedText();

  const settings = useRecoilValue(settingsAtom);

  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        flexWrap: 'nowrap',
        alignItems: 'center',
        alignSelf: 'start',
        maxWidth: '100%',
        overflow: 'hidden',
        ...props.sx,
      }}
    >
      <Link
        underline='hover'
        color='inherit'
        href='/'
        sx={{ flex: '0 0 auto' }}
      >
        <Typography sx={{ fontSize }}>
          {settings.settingsV1.storefront_navbar_text || t('common.homepage')}
        </Typography>
      </Link>

      <Separator />

      {breadcrumbElements
        .slice(0, breadcrumbElements.length - 1)
        .flatMap((el, i) => [
          <Link
            key={i}
            underline='hover'
            color='inherit'
            href={`/${el.url}`}
            sx={{ flex: '0 0 auto' }}
          >
            <Typography sx={{ fontSize }}>{el.name}</Typography>
          </Link>,
          <Separator />,
        ])}

      <Typography
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize,
        }}
      >
        {last(breadcrumbElements)?.name}
      </Typography>
    </Box>
  );
};
